import React, {Component} from 'react';
import {Api} from '../../api';
import TextFieldInput from '../Common/TextFieldInput'
import ButtonInput from '../Common/ButtonInput'
import Loader from '../Common/Loader'
import {PropyLogoIcon} from '../Common/Icons/Icons'
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import {InputAdornment, IconButton} from '@material-ui/core';
import {withRouter} from 'react-router';
import planeGIF from '../../../public/img/plane_animation.gif'
import './Signup.scss';

class Signup extends Component {

    state = {
        password: '',
        matchingPassword: '',
        email: '',
        errorMessage: '',
        showPassword: false,
        showMatchingPassword: false,
        sentConfirmation: false,
        token: null,
        isLoading: false,
        errors: {
            email: false,
            password: false,
            matchingPassword: false,
        },
        isValidRulePassword: false,
    };

    render() {
        const {
            password, showPassword, showMatchingPassword, matchingPassword, email, sentConfirmation, isLoading,
            errors, isValidRulePassword
        } = this.state;

        return (
            <div className="signup-popup">
                {isLoading && <Loader/>}
                <form className={`signup-popup__form ${sentConfirmation && 'email-sent'}`}>
                    <div className={'form-wrapper'}>
                    <header className="signup-popup__header">
                        {sentConfirmation ?
                            <h3 className="signup-popup__second-title"><b>Confirm your email address!</b></h3> :
                            <div className={'content-logo'}>
                                <div className={'ts-logo-rectangle'}>
                                    <div className={'ts-logo'}>
                                        <div className={'symbol-t-logo'}>
                                            <svg width="47" height="38" viewBox="0 0 47 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M33.627 0.120605H46.0957V15.8457H42.9785C40.9375 15.8457 39.4346 15.6323 38.4697 15.2056C37.5049 14.7603 36.7441 14.2686 36.1875 13.7305C35.6494 13.1738 35.1855 12.4502 34.7959 11.5596C34.0166 9.74121 33.627 7.21777 33.627 3.98926V0.120605ZM15.6196 0.120605H30.5933V38H15.6196V0.120605ZM0.0336914 0.120605H12.5024V3.98926C12.5024 8.75781 11.6396 12.0049 9.91406 13.7305C8.50391 15.1406 6.24951 15.8457 3.15088 15.8457H0.0336914V0.120605Z" fill="#1B5DAA"/>
                                            </svg>
                                        </div>
                                        <div className={'symbol-s-logo'}>
                                            <svg width="37" height="38" viewBox="0 0 37 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M18.9316 0.120605H36.104V19.1855L18.9316 0.120605ZM0.757324 11.3091H0.590332C0.590332 7.48682 1.62939 4.6665 3.70752 2.84814C5.78564 1.02979 8.98633 0.120605 13.3096 0.120605L36.104 27.7856C36.104 31.4595 35.1113 34.085 33.126 35.6621C31.1963 37.2021 28.042 37.9722 23.6631 37.9722L0.757324 11.3091ZM0.673828 18.8237L17.2061 38H0.673828V18.8237Z" fill="#1B5DAA"/>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                                <div className={'logo-label'}>
                                    <p>
                                        TransferSign
                                    </p>
                                </div>
                                <div className={'logo-text'}>
                                    <p>
                                        Prove your services and pay net VAT,
                                        income tax or capital gains tax
                                        on cryptocurrency transactions
                                    </p>
                                </div>
                            </div>}
                    </header>

                    {sentConfirmation ?
                        <div className='p-t-20 sent-email-body'>
                            <div className="fields-row text-email-sent m-b-0">
                                A confirmation email has been sent to
                            </div>
                            <div className="fields-row text-email-sent m-b-0">
                                <b>{email}</b>
                            </div>
                            <div className="plane-gif">
                                <img src={planeGIF} alt="Email sent"/>
                            </div>
                            <div className="fields-row text-something-wrong">
                                Something wrong?
                            </div>
                            <div className="fields-row text-tips-email m-b-0">
                                - I didn't receive the confirmation email:&nbsp;
                                <span onClick={this.sendEmailAgain} className='password-link'>send again</span>!
                            </div>
                            <div className="fields-row text-tips-email">
                                - Not your email address?&nbsp;
                                <span className='password-link'
                                      onClick={() => this.setState({sentConfirmation: false})}>Go back to sign up!</span>
                            </div>
                        </div>
                        :
                        <div className="signup-popup__body">
                            <div className="fields-row m-t-20">
                                <TextFieldInput name='email'
                                                label='Email'
                                                value={email}
                                                history={this.props.history}
                                                error={errors.email}
                                                required={true}
                                                classes='width-400'
                                                handleChange={(e) => this.handleChange(e)}/>
                            </div>
                            <div className="fields-row">
                                <TextFieldInput name='password'
                                                hint='8 characters include: 1 uppercase, 1 digit, 1 lowercase'
                                                isValidRule={isValidRulePassword}
                                                label='Password'
                                                type={showPassword ? 'text' : 'password'}
                                                classes='width-400 p-r-0'
                                                value={password}
                                                error={errors.password}
                                                required={true}
                                                endAdornment={{
                                                    endAdornment: (
                                                        <InputAdornment position="end" classes={{
                                                            root: 'root-input-adornment'
                                                        }}>
                                                            <IconButton
                                                                aria-label="Toggle password visibility"
                                                                onClick={() => this.setState({showPassword: !showPassword})}
                                                                onMouseDown={this.handleMouseDownPassword}
                                                            >
                                                                {showPassword ? <VisibilityOff/> :
                                                                    <Visibility/>}
                                                            </IconButton>
                                                        </InputAdornment>
                                                    )
                                                }}
                                                handleChange={(e) => this.handleChange(e)}/>
                            </div>
                            <div className="fields-row">
                                <TextFieldInput name='matchingPassword'
                                                label='Confirm Password'
                                                type={showMatchingPassword ? 'text' : 'password'}
                                                classes='width-400 p-r-0'
                                                error={errors.matchingPassword}
                                                value={matchingPassword}
                                                required={true}
                                                endAdornment={{
                                                    endAdornment: (
                                                        <InputAdornment position="end" classes={{
                                                            root: 'root-input-adornment'
                                                        }}>
                                                            <IconButton
                                                                aria-label="Toggle password visibility"
                                                                onClick={() => this.setState({showMatchingPassword: !showMatchingPassword})}
                                                                onMouseDown={this.handleMouseDownPassword}
                                                            >
                                                                {showMatchingPassword ? <VisibilityOff/> :
                                                                    <Visibility/>}
                                                            </IconButton>
                                                        </InputAdornment>
                                                    )
                                                }}
                                                handleChange={(e) => this.handleChange(e)}/>
                            </div>
                            <div className="fields-row">
                                <ButtonInput className='blue-button width-400'
                                             title='Sign Up'
                                             handleClick={(e) => this.onSubmit(e)}/>
                            </div>
                            <div className="fields-row">
                                Already have an account? <span onClick={() => this.props.history.push('/')}
                                                               className='m-l-20 password-link'>Sign In</span>
                            </div>
                        </div>
                    }
                    </div>
                </form>
            </div>
        )
    }

    handleChange = event => {
        console.log(event.target.name, event.target.value, 'handle change')

        let {errors, isValidRulePassword} = this.state;
        errors[event.target.name] = false;

        if (event.target.name === 'password' && event.target.value) {
            Api.get(`user/check/password?password=${event.target.value}`).then((response) => {
                console.log(response, response.status, response.data, 'response check password')
                isValidRulePassword = response.status === 200 && response.data === 'Success';
                this.setState({isValidRulePassword});
            }).catch((error) => {
                this.setState({isValidRulePassword: false});
                console.log(error, 'error')
            });
        }
        //
        // if (event.target.name === 'username') {
        //     isValidRuleUsername = event.target.value.length > 3;
        // }

        this.setState({
            [event.target.name]: event.target.value,
            errors,
        });
    };

    sendEmailAgain = () => {
        this.setState({isLoading: true});
        Api.get(`user/resend_registration_token?token=${this.state.token}`).then((response) => {
            this.setState({isLoading: false});
            console.log(response, 'response resend email')
            if (response.data.status !== '409') {
                alert('email sent')
            } else {
                alert(response.data.message)
            }
        }).catch((error) => {
            this.setState({isLoading: false});
            alert('error')
            console.log(error, 'error')
        });
    };

    onSubmit = (e) => {
        e.preventDefault();

        if (this.formValidate()) {
            this.setState({isLoading: true});
            Api.post('user/registration', {
                username: this.state.username,
                firstName: this.state.firstName,
                lastName: this.state.lastName,
                password: this.state.password,
                matchingPassword: this.state.matchingPassword,
                email: this.state.email,
            }).then((response) => {
                console.log(response, 'response')
                this.setState({isLoading: false});
                if (response.data.status !== '409') {
                    this.setState({
                        sentConfirmation: true,
                        token: response.data,
                        password: '',
                        matchingPassword: '',
                    })
                }
            }).catch((error) => {
                this.setState({isLoading: false});
                alert(error.response.data)
            })
        }
    };

    handleMouseDownPassword = event => {
        event.preventDefault();
    };

    formValidate = () => {
        const {username, firstName, lastName, password, matchingPassword, email, errors} = this.state;

        let isValid = true;

        // if (!username) {
        //     errors.username = 'The username field is required';
        //     isValid = false;
        // } else if (username.length < 4) {
        //     errors.username = 'Username should be at least 4 characters';
        //     isValid = false;
        // } else {
        //     Api.get(`doc-chain/access/check/username/${username}`).then((response) => {
        //         console.log(response, 'response check username')
        //         if (response.status === 200 && response.data === 'Success') {
        //             errors.username = false;
        //         } else {
        //             errors.username = 'This username is already taken. Please choose another username';
        //             isValid = false;
        //         }
        //         this.setState({errors});
        //     }).catch((error) => {
        //         console.log(error, 'error')
        //         errors.username = error.response.data;
        //         this.setState({errors});
        //         isValid = false;
        //     });
        // }

        // if (!firstName) {
        //     errors.firstName = 'The first name field is required';
        //     isValid = false;
        // } else {
        //     errors.firstName = false;
        // }
        //
        // if (!lastName) {
        //     errors.lastName = 'The last name field is required';
        //     isValid = false;
        // } else {
        //     errors.lastName = false;
        // }

        if (!email) {
            errors.email = 'The email field is required';
            isValid = false;
        } else if (email.search("@") === -1) {
            errors.email = 'Please check your email address, it should contain the @ symbol';
            isValid = false;
        } else {
            Api.get(`user/check/email?email=${email}`).then((response) => {
                console.log(response, 'response check email')
                if (response.status === 200 && response.data === 'Success') {
                    errors.email = false;
                } else {
                    errors.email = 'email-exist';
                    isValid = false;
                }
                this.setState({errors});
            }).catch((error) => {
                console.log(error, 'error')
                if (error.response.data === 'Domain is not registered!') {
                    errors.email = error.response.data;
                } else {
                    errors.email = 'email-exist';
                    console.log(errors.email, 'errors.email')
                }
                this.setState({errors});
                isValid = false;
            });
        }

        if (!password) {
            errors.password = 'The password field is required';
            isValid = false;
        } else {
            Api.get(`user/check/password?password=${password}`).then((response) => {
                console.log(response, 'response check password')
                if (response.status === 200 && response.data === 'Success') {
                    errors.password = false;
                } else {
                    errors.password = 'Password should be at least 8 characters, including 1 uppercase, 1 digit, 1 lowercase';
                    isValid = false;
                }
                this.setState({errors});
            }).catch((error) => {
                console.log(error, 'error')
                errors.password = error.response.data;
                this.setState({errors});

                isValid = false;
            });
        }

        if (!matchingPassword) {
            errors.matchingPassword = 'The confirm password field is required';
            isValid = false;
        } else if (matchingPassword !== password) {
            errors.matchingPassword = 'Passwords do not match';
            isValid = false;
        } else {
            errors.matchingPassword = false;
        }

        this.setState({errors});

        return isValid;
    }
}

export default withRouter(Signup);



// WEBPACK FOOTER //
// ./src/components/Signup/Signup.js